import { useEffect, useRef } from "react";
import WaterSystemSummaryTable from './WaterSystemSummaryTable';
import { useWaterSystemSearchModal } from "../reuseableComponents/WaterSystemSearchModalContext";

const WaterSystemDetailedInfoPage = () => {
  const selectedWaterSystem = JSON.parse(sessionStorage.getItem("selectedWaterSystem") || "{}");
  const { showSystemSelectModal, setShowSystemSelectModal } = useWaterSystemSearchModal();
  const modalOpenedRef = useRef(false);

  useEffect(() => {
    // If selectedWaterSystem is not populated and modal is not already open, open the modal
    if ((!selectedWaterSystem || Object.keys(selectedWaterSystem).length === 0) && !showSystemSelectModal && !modalOpenedRef.current) {
      setShowSystemSelectModal(true);
      modalOpenedRef.current = true;
    }
  }, [selectedWaterSystem, showSystemSelectModal, setShowSystemSelectModal]);

  return (
    <div className="water-system-summary">
      <h4>Detailed Info</h4>
      <br />
      {selectedWaterSystem && Object.keys(selectedWaterSystem).length > 0 && (
        <WaterSystemSummaryTable selectedWaterSystem={selectedWaterSystem} />
      )}
    </div>
  );
}
export default WaterSystemDetailedInfoPage;